<template>
  <v-container fluid class="payrollrecurring-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Payroll Recurring</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="7">
                      <p class="text-h5">New Recurring Item</p>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-select
                          class="mb-4"
                          :items="employees.filter(employee=>employee.employeestatus=='Active').map(x => {return {text: x.employeename, value: x._id};})"
                          v-model="payrollrecurring.employeeid"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Employee"
                          persistent-hint
                          single-line hint="Please choose the employee">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="accounts.filter(account=>account.accountclass=='Payroll').map(x => {return {text: x.accountname, value: x._id};})"
                          v-model="payrollrecurring.accountid"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Account"
                          persistent-hint
                          single-line hint="Please choose the account">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="payrollrecurring.paydesc"
                          outlined
                          dense
                          placeholder="Description"
                          persistent-hint
                          single-line hint="Enter the description">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-form>
                        <v-menu
                          ref="menu_paystartdate"
                          v-model="menu_paystartdate"
                          :close-on-content-click="false"
                          :return-value.sync="payrollrecurring.paystartdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="payrollrecurring.paystartdate"
                              placeholder="Start Date"
                              v-bind="attrs"
                              v-bind:value="payrollrecurring.paystartdate"
                              v-bind:error="errorindex == 2"
                              v-on="on"
                              single-line hint="Please choose the start date"
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="payrollrecurring.paystartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paystartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_paystartdate.save(payrollrecurring.paystartdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-text-field
                          type="number"
                          class="mb-4"
                          v-model="payrollrecurring.value"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Value"
                          persistent-hint
                          single-line hint="Enter the amount value">
                        </v-text-field>
                        <v-text-field
                          type="number"
                          class="mb-4"
                          v-model="payrollrecurring.valuelimit"
                          outlined
                          dense
                          placeholder="Annual Limit"
                          persistent-hint
                          single-line hint="Enter the annual limit">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-form>
                        <v-menu
                          ref="menu_payenddate"
                          v-model="menu_payenddate"
                          :close-on-content-click="false"
                          :return-value.sync="payrollrecurring.payenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="payrollrecurring.payenddate"
                              placeholder="End Date"
                              v-bind="attrs"
                              v-bind:value="payrollrecurring.payenddate"
                              v-bind:error="errorindex == 3"
                              v-on="on"
                              single-line hint="Please choose the end date"
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="payrollrecurring.payenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_payenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_payenddate.save(payrollrecurring.payenddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-select
                          class="mb-4"
                          :items=valuetypes
                          v-model="payrollrecurring.valuetype"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the value type">
                        </v-select>
                        <v-switch
                          v-model="payrollrecurring.paystatus"
                          color="primary"
                          v-bind:label="payrollrecurring.paystatus"
                          value="Active"
                        ></v-switch>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="7">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/payrollrecurring/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createPayrollRecurring()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      payrollrecurring: {
        paystatus: 'Active'
      },
      valuetypes: ['Amount', 'Percentage'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      menu_payenddate: null,
      menu_paystartdate: null,
    }
  },

  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Employee', ['getEmployeesRequest']),
    ...mapActions('PayrollRecurring', ['insertPayrollRecurring','getPayrollRecurringsRequest']),
    checkError(){
      if(!this.payrollrecurring.employeeid){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.payrollrecurring.accountid){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.payrollrecurring.paystartdate){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.payrollrecurring.payenddate){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.payrollrecurring.value){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.payrollrecurring.valuetype){
        this.haserrors = true;
        this.errorindex = 5;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async createPayrollRecurring() {
      if(!this.checkError()) return;
      await this.insertPayrollRecurring(this.payrollrecurring);
      router.push('/payrollrecurring/list');
    },
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
    ...mapState('PayrollRecurring', ['isReceiving']),
  },
  async created() {
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.employees.length==0) await this.getEmployeesRequest();
  },
}
</script>

<style src="./Add.scss" lang="scss"></style>
